var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.colClass},[_c(_vm.component,{tag:"component",attrs:{"path":_vm.path,"label":_vm.field.label,"groupReadOnly":_vm.groupReadOnly,"upload-operation-id":_vm.fieldProps || 'DocStorage_uploadDocument'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }